import Button from '~components/ui/button'

type ConsultationErrorProps = Readonly<{
  onRetry: () => void
}>

const ConsultationError = ({ onRetry }: ConsultationErrorProps) => {
  return (
    <div className="mx-auto flex h-screen animate-fade-in-400ms flex-col justify-center lg:max-w-[720px]">
      <div className="relative flex flex-col items-center justify-center flex-gap-y-4 px-5 py-6">
        <img
          src={`${import.meta.env.VITE_STATIC_RES}/img/error_dog.webp`}
          width={138}
          height={130}
          alt="error"
        />
        <h1 className="text-primary-600 text-headline-3">Unable to submit</h1>
        <p className="text-center text-primary-600 text-body-2 lg:whitespace-pre-line lg:text-body-3">
          {`Your question has been saved successfully,\nbut we could not submit it due to a technical issue on our end. `}
          <br />
          <br />
          {`Please submit your question again.\nContact support@drtail.us if this issue continues.`}
        </p>
      </div>
      <div className="flex w-full flex-col items-center px-5 pb-5">
        <Button onClick={onRetry} className="w-full lg:w-[335px]">
          Retry
        </Button>
      </div>
    </div>
  )
}

export default ConsultationError
